import type {TabId} from '../types';
import {exists} from 'shared/utils/custom-utils';

type StorageShape = Record<string, Record<string, TabId>>;

class TabPagesMenuStorage {

    private static STORAGE_KEY = 'tabPagesMenuStorage';

    public getLastSelectedTabId(menuId: string, groupId: string): TabId | null {
        const data = this.readStorage();
        return data[menuId]?.[groupId] ?? null;
    }

    public saveLastSelectedTabId(menuId: string, groupId: string, tabId: TabId | null): void {
        const data = this.readStorage();

        if (!exists(tabId) || groupId === tabId) {
            if (data[menuId]) {
                delete data[menuId][groupId];

                if (Object.keys(data[menuId]).length === 0) {
                    delete data[menuId];
                }

                this.writeStorage(data);
            }

            return;
        }

        data[menuId] ??= {};
        data[menuId][groupId] = tabId;

        this.writeStorage(data);
    }

    private readStorage(): StorageShape {
        try {
            const raw = localStorage.getItem(TabPagesMenuStorage.STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    }

    private writeStorage(data: StorageShape): void {
        localStorage.setItem(TabPagesMenuStorage.STORAGE_KEY, JSON.stringify(data));
    }
}

export const tabPagesMenuStorage = new TabPagesMenuStorage();